import { VersionsActionTypes } from '../types';
import { makeActionCreator, makeAsyncActionCreators } from '../../helpers';

const getDataToCompareVersions = makeAsyncActionCreators(
  VersionsActionTypes.getDataToCompareVersions,
  ['projectId', 'chapterNumber'],
  ['versions', 'chapters', 'project'],
  ['error'],
);

const addVersion = makeAsyncActionCreators(
  VersionsActionTypes.addVersion,
  [
    'chapterIndex',
    'chapter',
    'author',
    'reason',
    'redirectPageUrl',
    'allChapters',
    'shouldCreate',
    'navigate',
  ],
  ['version'],
  ['error'],
);

const setShouldCreateVersion = makeActionCreator(
  VersionsActionTypes.setShouldCreateVersion,
  ['value'],
);

const restoreVersion = makeAsyncActionCreators(
  VersionsActionTypes.restoreVersion,
  ['versionId', 'callback'],
  ['versions'],
  ['error'],
);

export default {
  getDataToCompareVersions,
  addVersion,
  setShouldCreateVersion,
  restoreVersion,
};
